export default {

  //用户中心，我的订单菜单
  myorders: [
    {
      tag: "orderMenu",
      index: 1,
      title: "待付款",
      icon: "daifukuan1"
    },
    {
      tag: "orderMenu",
      index: 2,
      title: "待发货",
      icon: "daifahuo1"
    },
    {
      tag: "orderMenu",
      index: 3,
      title: "待收货",
      icon: "daishouhuo1"
    },
    {
      tag: "orderMenu",
      index: 4,
      title: "我的评价",
      icon: "daipingjia2"
    }
  ],
  //用户中心，我的订单菜单
  coreServices: [
    {
      tag: "mycoupon",
      title: "优惠券",
      icon: "youhuiquan-copy"
    },
    {
      tag: "favourate",
      title: "我的收藏",
      icon: "shoucang"
    }
  ],
  appTools: [
    {
      tag: "addressManagement",
      title: "地址管理",
      icon: "dizhiguanli"
    },
    {
      tag: "feedback",
      title: "意见反馈",
      icon: "fankui"
    },
    {
      tag: "aboutus",
      title: "关于我们",
      icon: "emiguanyuwomen"
    }
  ]

}



// WEBPACK FOOTER //
// ./src/config/userCenterMenus.js